module.exports = __webpack_public_path__ + "static/img/1-2.bbe4828.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/1-2.png
// module id = NvGZ
// module chunks = 0